import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilty, AppMetadataHandler } from 'app';
import * as moment from 'moment';
import { FwaDashboardService } from '../fwa-dashboard/fwa-dashboard.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApexNonAxisChartSeries, ApexAxisChartSeries, ApexChart, ApexPlotOptions, ApexTitleSubtitle, ApexFill, ApexStroke, ChartComponent, ApexDataLabels, ApexXAxis, ApexYAxis, ApexMarkers } from "ng-apexcharts";
import { environment } from 'environments/environment';
import FWARulesLocalJSON from './fwa-rules.json';

export type fraudGaugeChartOption = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  colors: string[];
};

export type involvementMetricsChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  title: ApexTitleSubtitle;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  tooltip: any;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  colors: string[];
  yaxis: ApexYAxis;
  markers: ApexMarkers;
  xaxis: ApexXAxis;
};

export type peculiarPatternChartOption = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};

@Component({
  selector: 'app-fwa-analytics',
  templateUrl: './fwa-analytics.component.html',
  styleUrls: ['./fwa-analytics.component.scss']
})
export class FWAAnalyticsComponent implements OnInit {

  _currentComponentName = 'FWAAnalyticsComponent';

  constructor(private commonUtility: CommonUtilty,
    private fwaDashboardService: FwaDashboardService,
    private appMetadataHandler: AppMetadataHandler,
    private message: NzMessageService) {

    this.fraudOMeterChart = {};
    this.involvementMetricsChart = {};
    this.peculiarPatternChart = {};
  }

  @Input() configData = this.appMetadataHandler.configDataJSON;
  @Input() transactionState;
  @Input() smartUIConfig;
  extractedSmartUIConfig = {};

  _IO;
  @Input()
  set IO(data) {
    if (data) {
      if(!(this.appID && this.appLOB)){
        this.isFWAErrorResp = true;
        return;
      }
      this._IO = this.commonUtility.deepCopy(data);
      this.extractApplicationType();
      let requestData = this.generateFWARequest(data);
      this.fetchFraudProbability(requestData);
      this.fetchFWAPatterns(requestData);
      //this.renderInvolvementMetricsChart();
      this.extractFraudRules();
    }
  }


  lookupsToBind = [];
  lookup$ = this.commonUtility.initializeLookupList(this.lookupsToBind)

  isAngularVersion8 : boolean = false;
  appID: string = "NBU";
  appLOB: string = "HEALTH";
  ngOnInit(): void {
    // this.extractedSmartUIConfig = this.commonUtility.extractSmartUIConfig(this.smartUIConfig);
    // this.appID = this.extractedSmartUIConfig['appID'];
    // this.appLOB = this.extractedSmartUIConfig['appLOB'];
    this.isAngularVersion8 = this.commonUtility.angularVersion() <= 8;
  }

  /************Loader and its messages************/
  isLoadingFWAData = false;
  isLoadingFWAPattern: boolean = false;
  FWADataLoadingMsg = 'Processing Request. . .';
  pseudoLoad(t = 0) {
    this.isLoadingFWAData = true;
    let totalFakeLoadTime = t || 51250; //5125
    let divisions = 5;
    setTimeout(() => { this.FWADataLoadingMsg = "Initializing AI models . . ." }, ~~(totalFakeLoadTime / divisions) * 2);
    setTimeout(() => { this.FWADataLoadingMsg = "Computing fraud detection scores . . ." }, ~~(totalFakeLoadTime / divisions) * 4);
    setTimeout(() => { this.FWADataLoadingMsg = "Evaluating key metrics . . ." }, ~~(totalFakeLoadTime / divisions) * 6);
    setTimeout(() => { this.FWADataLoadingMsg = "Scanning for distinctive patterns . . ." }, ~~(totalFakeLoadTime / divisions) * 7);
    setTimeout(() => { this.FWADataLoadingMsg = "Executing a variety of algorithms on the dataset . . ." }, ~~(totalFakeLoadTime / divisions) * 8);
    setTimeout(() => { this.FWADataLoadingMsg = "Deriving specialized intelligence insights . . ." }, ~~(totalFakeLoadTime / divisions) * 9);
    // setTimeout(()=>{this.isLoadingFWAData=false},totalFakeLoadTime+650);
  }
  /************END: Loader and its messages************/

  /************Extract and manipulate application Data************/
  applicationData = {};
  extractApplicationType() {
    let DOName = this.commonUtility.getDOName(this._IO);
    let result = {};

    switch (DOName) {
      case 'claimDO':
        result = { transactionNumProperty: 'claimNum', reviewer: 'Adjudicator' };
        break;
      case 'proposalDO':
        result = { transactionNumProperty: 'proposalNum', reviewer: 'Underwriter' };
        break;
      case 'caseDO':
        result = { transactionNumProperty: 'proposalNum', reviewer: 'Underwriter' };
        break;
      default:
        result = { transactionNumProperty: 'claimNum', reviewer: '' };
        break;
    }

    this.applicationData = result;
  }
  /************END: Extract and manipulate application Data************/

  /************Fetch fraud score and patterns************/
  peculiarPatterns: [];
  fraudulentPatterns = [];
  fraudRisk: string = null;
  fraudScore = 0;
  overallInvestigationRecommendation: string = null;
  tempTransactionCaseNum: string = null;
  isFWAErrorResp:boolean = false;
  isFWAPatternErrorResp:boolean = false;
  FWAErrorMsg = "Oops! Something went wrong on our end. Our team is already on it, and we'll have things back up and running smoothly as soon as possible. Thank you for your patience.";
  isFWADataMissing: boolean = false;
  FWAMissingDataList = [];

  generateFWARequest(resp) {
    let requestData = {};

    if(this.appID == 'CLAIM' && this.appLOB == 'HEALTH'){
      requestData =  this.generateHealthClaimRequest(resp);
    }
    else if(this.appID == 'CLAIM' && this.appLOB == 'LIFE'){
      requestData =  this.generateLifeClaimRequest(resp);
    }
    else if(this.appID == 'NBU' && this.appLOB == 'HEALTH'){
      requestData =  this.generateHealthNBURequest(resp);
    }
    else if(this.appID == 'NBU' && this.appLOB == 'LIFE'){
      requestData =  this.generateLifeNBURequest(resp);
    }

    return {
      //"product_type": "HEALTH_Claims",
      "product_type": `${this.appLOB}_${this.appID}`,
      "business_process": "FWARISKANALYSIS",
      //"module_name": "VisionIntelligence",
      "module_name": "RIGHTCREDIT",
      //"noOfExplanation": 7,
      "input_data": requestData
    };

  }

  generateHealthClaimRequest(resp){
    let DOName = this.commonUtility.getDOName(resp);
    let DO = resp[DOName] || {};
    this.tempTransactionCaseNum = DO[this.applicationData['transactionNumProperty']];
    let policy = DO.policy ? DO.policy.find(e => true) : null;
    let client = this.commonUtility.deepCopy(this.commonUtility.extractClientDOFromIOGeneric(resp, 'INSURED'));
    let insuredClient = client.find(e => true);
    let admissionDt = DO['claimHospitalisations'] && DO['claimHospitalisations'][0] ? this.commonUtility.isArrayIterable(DO['claimHospitalisations'][0]['admissionDt']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(DO['claimHospitalisations'][0]['admissionDt'])) : null : null;
    let input_data = {};
    if (Object.keys(DO).length > 0) {

      input_data = {
        "id": DO['id'] ? DO['id'].toString() : null,
        "SUM_INSURED": policy ? policy['sumInsured'] : null,
        "HIGH_CLAIM_AMOUNT": this.isHighClaimedAmount(DO['claimedAmt'], policy['sumInsured']),
        "UNCMN_ACUTE_MDCL_ILLNESS": this.isClaimNumberOddOrEven(this.tempTransactionCaseNum),
        "COMMENCEMENT_DT": this.commonUtility.isArrayIterable(policy['commencementDt']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(policy['commencementDt'])) : null,
        "POLICY_EXPIRY_DT": this.commonUtility.isArrayIterable(policy['expiryDt']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(policy['expiryDt'])) : null,
        "DOB": insuredClient['dateOfBirth']  ? this.formattedDate(insuredClient['dateOfBirth'], 'DD/MM/YYYY') : null,
        "AGE": this.computeAge(insuredClient['dateOfBirth'], admissionDt),
        "INTIMATION_DT": this.commonUtility.isArrayIterable(DO['intimationDt']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(DO['intimationDt'])) : null,
        "INTIMATUON_TIME": this.commonUtility.isArrayIterable(DO['intimationTm']) ? this.commonUtility.serverDOtoUIDOsetTime(DO['intimationTm']) : null,
        "ACCIDENT_DT": this.commonUtility.isArrayIterable(DO['dateOfAccident']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(DO['dateOfAccident'])) : null,
        "ADMISSION_DT": admissionDt,
        "ADMISSION_TIME": DO['claimHospitalisations'] && DO['claimHospitalisations'][0] ? this.commonUtility.isArrayIterable(DO['claimHospitalisations'][0]['admissionTime']) ? this.commonUtility.serverDOtoUIDOsetTime(DO['claimHospitalisations'][0]['admissionTime']) : null : null,
        "DISCHARGE_DT": DO['claimHospitalisations'] && DO['claimHospitalisations'][0] ? this.commonUtility.isArrayIterable(DO['claimHospitalisations'][0]['dischargeDt']) ? this.formattedDate(this.commonUtility.serverDOtoUIDODate(DO['claimHospitalisations'][0]['dischargeDt'])) : null : null,
        "DISCHARGE_TIME": DO['claimHospitalisations'] && DO['claimHospitalisations'][0] ? this.commonUtility.isArrayIterable(DO['claimHospitalisations'][0]['dischargeTime']) ? this.commonUtility.serverDOtoUIDOsetTime(DO['claimHospitalisations'][0]['dischargeTime']) : null : null,
        "ICD_CD": DO['claimHospitalisations'] && DO['claimHospitalisations'][0] && DO['claimHospitalisations'][0]['claimDiagnosisDetails'] && DO['claimHospitalisations'][0]['claimDiagnosisDetails'][0] ? DO['claimHospitalisations'][0]['claimDiagnosisDetails'][0]['icdCd'] : null,
        "PROVIDER_NUM": DO['claimHospitalisations'] && DO['claimHospitalisations'][0] ? DO['claimHospitalisations'][0]['providerNum'] : null
      }
    }
    return input_data;
  }

  generateLifeClaimRequest(resp){
    //CODE COPIED FROM LIFE_CLAIM BRANCH
    let DOName = this.commonUtility.getDOName(resp);
    let DO = resp[DOName] || {};
    this.tempTransactionCaseNum = DO[this.applicationData['transactionNumProperty']];
    let client = this.commonUtility.deepCopy(this.commonUtility.extractClientDOFromIOGeneric(resp,'INSURED'));
    let insuredClient = client.find(e=>true);
    let proposal = DO.proposal? DO.proposal.find(e=>true) : null;
    let user = DO.claimUsers? DO.claimUsers.find(e=>true) : null;
    let TAT = this.getClaimTAT(DO);
    let input_data = {};
    if (Object.keys(DO).length > 0) {

      input_data = {
          "CASE_ID":DO.claimNum,
          "FINAL_BENEFIT_CREATE_DT": null,
          "CLAIM_ACK_NO": DO.claimNum,
          "POLICY_NO":proposal? proposal.proposalNum : "",
          "INSURED_CLIENT_ID":insuredClient.id.toString(),
          "INSURED_NAME":this.commonUtility.getNameFromClient(insuredClient)  ,
          "INSURED_GENDER":this.commonUtility.getGenderFromClient(insuredClient),
          "INSURED_DOB":this.formattedDate(this.commonUtility.getDateOfBirthFromClient(insuredClient)),
          "OCCP_CD":this.commonUtility.getOccupationFromClient(insuredClient),
          "OCCP_DESC":this.getLookupValue("occupationCd",insuredClient.occupationCd),
          "ANNUAL_SALARY":this.commonUtility.getIncomeFromClient(insuredClient).toString(),
          "PRODUCT_FAMILY_DESC":this.getLookupValue("productId",proposal.baseProductCd),
          "MEDICAL":proposal? proposal.medicalstatuscd : "",
          "POL_BILL_MODE_DESC": proposal? proposal.payoutOptionCd : "",
          "ISSUE_DT":proposal? this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(proposal.policyIssueDt)) : "",
          "LAST_LAPSE_DT":proposal? this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(proposal.lapseDt)) : "",
          "LAPS_STRT_DT":"",
          "LAST_REINS_DT":"",
          "REINS_COI_YN":"",
          "EVENT_DATE":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.eventDt)),
          "FINAL_INTIMATION_DATE":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.intimationDt)),
          "STATUS_DOI":proposal? this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(proposal.statusCd)) : "",
          "STATUS_DOE":proposal? this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(proposal.proposalStatusAtEvent)) : "",
          "POL_DUR_ISSUANCE_MNTHS":proposal.proposalAgeInMonths.toString(),
          "EARLY_YN":proposal? this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(proposal.earlyClaimFl)) : "",
          "INSURED_AGE_ON_EVENT":insuredClient.age,
          "ACTUAL_CAUSE":DO.causeOfDeathCd? DO.causeOfDeathCd : DO.illnessCd,
          "ACTUAL_CAUSE_OTHER":DO.causeOfEventDesc,
          "CLAIM_TYPE":DO.eventTypeCd,
          "RIDER_TYPE":"",
          "WOP_TYPE":proposal.wopCd,
          "BOOKING_DT":"30/12/2019",
          "BOOKING_AMT":this.commonUtility.getBenefitAmountFromDO(DO).toString(),
          "BRANCH_CODE_SRV":"0",
          "BRANCH_CODE_SRV_DESC":"",
          "Revised ASSIGNED_ZONE":"",
          "BRANCH_CODE_CI":"",
          "BRANCH_CODE_CI_DESC":"",
          "CI_BRANCH_ZONE":"",
          "SALES_CHANNEL":"",
          "AGT_SRV_CHANNEL_CD":"",
          "AGT_SRV_CODE":proposal? proposal.baseAgentId : "",
          "COMPANY_NAME":"",
          "AGENT_NAME":"",
          "BRANCH_MANAGER_INTIMATING_BRANCH":"",
          "AGENCY_MANAGER_CODE":"",
          "AGENCY_MANAGER_NAME":"",
          "BASE_SA":proposal? proposal.sumInsured : "",
          "RID_ACCIDENTAL":"0",
          "RID_CI":"0",
          "ENHANCE_SA":"0",
          "WOP":DO.claimSettlement.WopAmt ? DO.claimSettlement.WopAmt.toString() : "0",
          "BONUS":DO.claimSettlement.InterimBonusAmt? DO.claimSettlement.InterimBonusAmt.toString() : "0",
          "FV":"0",
          "FV_TBR":"0",
          "GFV":"0",
          "TROP":"0",
          "PRE_PMT_AMT":"0",
          "ADV_PREM": DO.claimSettlement.AdvancePremAmt? DO.claimSettlement.AdvancePremAmt.toString() : "0",
          "Return of Premium":DO.claimSettlement.premPaidPostDthAmt ? DO.claimSettlement.premPaidPostDthAmt.toString() : "0",
          "REFUND_PREM_POST_DOE":DO.claimSettlement.premPaidPostDthAmt ? DO.claimSettlement.premPaidPostDthAmt.toString() : "0",
          "CSV":"0",
          "ADJ_OTH_POS":"0",
          "ADJ_OTH_NEG":DO.claimSettlement.negativeAdjAmt ? DO.claimSettlement.negativeAdjAmt.toString() : "0",
          "ADJ_OTH_POS_REMARKS":"",
          "ADJ_OTH_NEG_REMARKS":"",
          "Total Amt":this.commonUtility.getBenefitAmountFromDO(DO).toString(),
          "Loan Amt":DO.claimSettlement.LoanAmt ? DO.claimSettlement.LoanAmt.toString() : "0",
          "DECISION_DT":DO.decisionDt,
          "DECISION_BY_USER": user.approverUserName,
          "LAST_REQUIREMENT_AS_ON_DT":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.lastDocRecDt)),
          "LAST_REQUIREMENT_DT":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.lastDocRecDt)),
          "CLAIM_STATUS":DO.derivedStatus,
          "REASON":DO.statusReasonCd,
          "DISBURSEMENT_AMT":this.commonUtility.getBenefitAmountFromDO(DO).toString(),
          "Last Letter Dt":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.lastCommunicationDate)),
          "DISPATCH_DT":this.commonUtility.formatDateToDDMMYYYY(this.commonUtility.serverDOtoUIDODate(DO.dispatchDt)),
          "Final dt":"",
          "ASSESSOR_NAME":DO.currentTaskUser,
          "Invt (Y/N)":DO.investigationFlag == 1? "Y" : "N",
          "TAT till dispatch":TAT?TAT : "0",
          "PAYMENT_MODE":"NEFT",
          "Invest Raised Date":"",
          "Invest Closure Date":"",
          "IRDA Removal":"0",
          "Segment":"",
          "Age proof":"",
          "Networkdays TAT":"1",
          "Prem recd til date":"",
          "Natural/Unnatural": DO.typeOfDeathCd,
          "Product Category":proposal? proposal.baseProductTypeCd : "",
          "INSTRUMENT_NO":"",//claim payment
          "INSTRUMENT_DT_FRMT":"",//claim payment
          "TRANSACTION_STATUS":"",//claim payment TRANSACTION_STATUS
          "VOUCHER_DATE_FRMT":"",//claim payment
          "PAYEE_NAME":"",//claim payment
          "PAYMENT_DT_FRMT":"",//claim payment
          "Assessor Remarks":DO.adjRemarks,
          "Approver Remarks":DO.adj2Remarks,
          "Beneficiary Name":"",
          "Address1":"",
          "Address2":"",
          "Address3":"",
          "Address4":"",
          "Mobile Number":this.commonUtility.getContactNumFromClient(insuredClient),
          "Email Id": this.commonUtility.getEmailFromClient(insuredClient) 
      }
    }
    return input_data;
  }

  generateHealthNBURequest(resp){
    let DOName = this.commonUtility.getDOName(resp);
    let DO = resp[DOName] || {};
    this.tempTransactionCaseNum = DO[this.applicationData['transactionNumProperty']];
    let client = this.commonUtility.deepCopy(this.commonUtility.extractClientDOFromIOGeneric(this._IO, 'PRIMARYINSURED'));
    let agent = resp['agentDOs'] ? resp['agentDOs'].find(e => true) : null;
    let insuredClient = client.find(e => true);

    let input_data = {};
    if(Object.keys(DO).length > 0){

      input_data = {
        "cibilScore": insuredClient['cibilScore'],
        "clientTypeCd": insuredClient['clientTypeCd'],
        "blackListedFl_client": insuredClient['blackListedFl'],
        "politicalFl": insuredClient['politicalFl'],
        "postCode": insuredClient['postCode'],
        "statusCd": DO['statusCd'],
        "premiumStatusCd": DO['premiumStatusCd'],
        "policyTypeCd": DO['policyTypeCd'],
        "baseProductFamilyCd": DO['baseProductFamilyCd'],
        "policyTerm": DO['policyTerm'],
        "finalPremiumAmt": DO['finalPremiumAmt'],
        "planTypeCd": DO['basePlanCd'],
        "productCd": DO['baseProductCd'],
        "productTypeCd": DO['baseProductTypeCd'],
        "term": DO['policyTerm'],
        "totalPremium": DO['totPremPaidAmt'],
        "roleCd": "PRIMARYINSURED",
        "discount": 97.0, // TODO
        "commission": 49.0, // TODO
        "createdDate": DO['createdDt']  ? this.formattedDate(DO['createdDt']) : null,
        "updatedDate": DO['updatedDt']  ? this.formattedDate(DO['updatedDt']) : null,
        "proposalEntryDate": DO['proposalEntryDt']  ? this.formattedDate(DO['proposalEntryDt']) : null,
        "proposalReceivedDate": DO['proposalReceivedDt']  ? this.formattedDate(DO['proposalReceivedDt']) : null,
        "proposalSignedDate": DO['proposalSignedDt']  ? this.formattedDate(DO['proposalSignedDt']) : null,
        "policyCommencementDate": DO['policyCommencementDt']  ? this.formattedDate(DO['policyCommencementDt']) : null,
        "policyExpiryDate": DO['policyExpiryDt']  ? this.formattedDate(DO['policyExpiryDt']) : null,
        "policyIssueDate": DO['policyIssueDt']  ? this.formattedDate(DO['policyIssueDt']) : null,
        "ageOfPolicy": DO['issueAge'],
        "dateDifferences": "3 days", // TODO
        "blacklistedFl_agent": agent['isBlacListed'],
        "clientNum": insuredClient['clientNum'],
        "proposalNum": DO['proposalNum']
      }
      
    }
    return input_data;
  }

  generateLifeNBURequest(resp){
    let DOName = this.commonUtility.getDOName(resp);
    let DO = resp[DOName] || {};
    this.tempTransactionCaseNum = DO[this.applicationData['transactionNumProperty']];
    let client = this.commonUtility.deepCopy(this.commonUtility.extractClientDOFromIOGeneric(this._IO, 'PRIMARYINSURED'));
    let agent = resp['agentDOs'] ? resp['agentDOs'].find(e => true) : null;
    let insuredClient = client.find(e => true);

    let input_data = {};
    if(Object.keys(DO).length > 0){

      input_data = {
        "cibilScore": insuredClient['cibilScore'],
        "clientTypeCd": insuredClient['clientTypeCd'],
        "blackListedFl_client": insuredClient['blackListedFl'],
        "politicalFl": insuredClient['politicalFl'],
        "postCode": insuredClient['postCode'],
        "statusCd": DO['statusCd'],
        "premiumStatusCd": DO['premiumStatusCd'],
        "policyTypeCd": DO['policyTypeCd'],
        "baseProductFamilyCd": DO['baseProductFamilyCd'],
        "policyTerm": DO['policyTerm'],
        "finalPremiumAmt": DO['finalPremiumAmt'],
        "planTypeCd": DO['basePlanCd'],
        "productCd": DO['baseProductCd'],
        "productTypeCd": DO['baseProductTypeCd'],
        "term": DO['policyTerm'],
        "totalPremium": DO['totPremPaidAmt'],
        "roleCd": "PRIMARYINSURED",
        "discount": 97.0, // TODO
        "commission": 49.0, // TODO
        "createdDate": DO['createdDt']  ? this.formattedDate(DO['createdDt']) : null,
        "updatedDate": DO['updatedDt']  ? this.formattedDate(DO['updatedDt']) : null,
        "proposalEntryDate": DO['proposalEntryDt']  ? this.formattedDate(DO['proposalEntryDt']) : null,
        "proposalReceivedDate": DO['proposalReceivedDt']  ? this.formattedDate(DO['proposalReceivedDt']) : null,
        "proposalSignedDate": DO['proposalSignedDt']  ? this.formattedDate(DO['proposalSignedDt']) : null,
        "policyCommencementDate": DO['policyCommencementDt']  ? this.formattedDate(DO['policyCommencementDt']) : null,
        "policyExpiryDate": DO['policyExpiryDt']  ? this.formattedDate(DO['policyExpiryDt']) : null,
        "policyIssueDate": DO['policyIssueDt']  ? this.formattedDate(DO['policyIssueDt']) : null,
        "ageOfPolicy": DO['issueAge'],
        "dateDifferences": "3 days", // TODO
        "blacklistedFl_agent": agent['isBlacListed'],
        "clientNum": insuredClient['clientNum'],
        "proposalNum": DO['proposalNum']
      }

    }
    return input_data;
  }


  isHighClaimedAmount(claimAmount, sumInsuredAmount) {
    // Calculate 75% of the sum insured
    const seventyFivePercentOfSumInsured = 0.75 * sumInsuredAmount;
    // Check if the claim amount is more than 75% of the sum insured
    return claimAmount > seventyFivePercentOfSumInsured ? "Yes" : "No";
  }

  isClaimNumberOddOrEven(claimNumber) {
    // Extract the numeric part of the claim number
    const claimNumberNumericPart = parseInt(claimNumber.match(/\d+/)[0]);
    // Check if the numeric part is odd or even
    return claimNumberNumericPart % 2 === 0 ? "No" : "Yes";
  }

  getClaimTAT(DO){
    //CODE COPIED FROM LIFE_CLAIM BRANCH
    let claimTAT = null;
    let fromDate = null;
    let intimationDate = this.commonUtility.serverDOtoUIDODate(DO.intimationDt)
    let currentDate = new Date();
    if (DO && DO.dispatchDt) {
      fromDate = this.commonUtility.serverDOtoUIDODate(DO.dispatchDt)
      claimTAT = Math.floor((Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()) - Date.UTC(intimationDate.getFullYear(), intimationDate.getMonth(), intimationDate.getDate()) ) /(1000 * 60 * 60 * 24));
    } else if (DO && DO.lastCommunicationDate) {
      fromDate = this.commonUtility.serverDOtoUIDODate(DO.lastCommunicationDate)
      claimTAT = Math.floor((Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()) - Date.UTC(intimationDate.getFullYear(), intimationDate.getMonth(), intimationDate.getDate()) ) /(1000 * 60 * 60 * 24));
    } else {
      claimTAT = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(intimationDate.getFullYear(), intimationDate.getMonth(), intimationDate.getDate()) ) /(1000 * 60 * 60 * 24));
    }

    console.log("tat calculate: ", claimTAT)
    return claimTAT
  }

  getLookupValue(lookupCd, matchVal) {
    //CODE COPIED FROM LIFE_CLAIM BRANCH
    let val = null
    this.lookup$[lookupCd].subscribe(lookupData => {
      if (lookupData && Array.isArray(lookupData))
        lookupData.forEach(element => {
          if (element.lookupKey == matchVal)
            val = element.lookupValue
        });
    })
    return val
  }

  fetchFraudProbability(requestData) {
    this.pseudoLoad();

    this.fwaDashboardService.fetchFraudProbability(requestData).subscribe(resp => {
      if (resp && Object.keys(resp).length > 0 && !resp.isError) {
        this.fraudScore = resp.predictionProbabilityPercent;
        this.fraudRisk = resp.modelPrediction;
        /*this.peculiarPatterns = resp.LimeExplanation;
        this.fraudulentPatterns = resp.FraudulentPatterns;
        this.overallInvestigationRecommendation = resp.overallInvestigationRecommendation;
        if(this.commonUtility.isArrayIterable(resp.warning)){
          this.isFWADataMissing = true;
          this.FWAMissingDataList = [...resp.warning];
        }
        this.renderPeculiarPatternChart();*/
        this.renderInvolvementMetricsChart();

        // this.peculiarPatternData['datasets'] = [
        //   { axis: 'y',  data: this.calculatePeculiarPatternImpactWeightNLabel()['data'], label: 'Peculiar Pattern Impact' }
        // ]
        // this.peculiarPatternData['labels'] = this.calculatePeculiarPatternImpactWeightNLabel()['label'];

      } /*else if (environment['demo']) {
        if (!this.fraudScore) {
          let existingScore = this.fetchScoreFromLocalStorage(this.tempTransactionCaseNum);

          if (existingScore) {
            this.fraudScore = existingScore;
          } else {
            this.fraudScore = Math.floor(Math.random() * (85 - 60 + 1)) + 60;
            this.storeScoreToLocalStorage(this.tempTransactionCaseNum, this.fraudScore);
          }
        }
      }*/
      else {
        this.isFWAErrorResp = true;
      }
      this.isLoadingFWAData = false;
      this.renderFraudOMeterChart();
    });

  }

  fetchFWAPatterns(requestData) {
    this.isLoadingFWAPattern = true;

    this.fwaDashboardService.fetchFWAPattern(requestData).subscribe(resp => {
      if (resp && Object.keys(resp).length > 0 && !resp.isError) {
        /*this.fraudScore = resp.predictionProbabilityPercent;
        this.fraudRisk = resp.modelPrediction;*/
        this.peculiarPatterns = resp.LimeExplanation;
        this.fraudulentPatterns = resp.FraudulentPatterns;
        this.overallInvestigationRecommendation = resp.overallInvestigationRecommendation;
        if(this.commonUtility.isArrayIterable(resp.warning)){
          this.isFWADataMissing = true;
          this.FWAMissingDataList = [...resp.warning];
        }
        //this.renderInvolvementMetricsChart();
        this.renderPeculiarPatternChart();
        // this.peculiarPatternData['datasets'] = [
        //   { axis: 'y',  data: this.calculatePeculiarPatternImpactWeightNLabel()['data'], label: 'Peculiar Pattern Impact' }
        // ]
        // this.peculiarPatternData['labels'] = this.calculatePeculiarPatternImpactWeightNLabel()['label'];

      } /*else if (environment['demo']) {
        if (!this.fraudScore) {
          let existingScore = this.fetchScoreFromLocalStorage(this.tempTransactionCaseNum);

          if (existingScore) {
            this.fraudScore = existingScore;
          } else {
            this.fraudScore = Math.floor(Math.random() * (85 - 60 + 1)) + 60;
            this.storeScoreToLocalStorage(this.tempTransactionCaseNum, this.fraudScore);
          }
        }
      }*/
      else {
       this.isFWAPatternErrorResp = true;
      }
      this.isLoadingFWAPattern = false;
      //this.isLoadingFWAData = false;
      //this.renderFraudOMeterChart();
    });

  }

  fetchScoreFromLocalStorage(key) {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  storeScoreToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  /************END : Fetch fraud score and patterns************/

  /************Peculiar Pattern chart rendering************/

  public peculiarPatternChart: Partial<peculiarPatternChartOption>;

  renderPeculiarPatternChart() {
    let ppLabelData = this.calculatePeculiarPatternImpactWeightNLabel();
    if (!this.commonUtility.isArrayIterable(ppLabelData['data'])) {
      return;
    }
    setTimeout(() => {
      this.peculiarPatternChart = {
        series: [
          {
            name: "Impact",
            data: ppLabelData['data'],
          },
        ],
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ppLabelData['label'],
        },
      };
    }, 2000);
  }

  /*public peculiarPatternChartType = 'horizontalBar';
  public peculiarPatternData = {
    labels: [],
    datasets: []
  };
  public peculiarPatternChartOptions = {
    type: 'bar',
    data: this.peculiarPatternData,
    options: {
      indexAxis: 'x',
      // Elements options apply to all of the options unless overridden in a dataset
      // In this case, we are setting the border of each horizontal bar to be 2px wide
      elements: {
        bar: {
          borderWidth: 2,
        }
      },
      responsive: true,
      plugins: {
        legend: {
          position: 'right',
        },
        title: {
          display: true,
          text: 'Impact on fraud propensity'
        }
      }
    }
  };*/

  calculatePeculiarPatternImpactWeightNLabel() {
    let tempList = {
      'data': [],
      'label': []
    };
    if (this.commonUtility.isArrayIterable(this.peculiarPatterns)) {
      this.peculiarPatterns.forEach((p_pattern, index) => {
        if (isNaN(p_pattern['impactWeight'])) {
          tempList['data'].push(0);
          tempList['label'].push("Pattern #" + Number(index + 1));
        } else {
          tempList['data'].push((p_pattern['impactWeight'] * 100).toFixed(2));
          tempList['label'].push("Pattern #" + Number(index + 1));
          //tempList['label'].push(p_pattern['summary']);
        }
      });
    }

    return tempList;
  }

  /************END: Peculiar Pattern chart rendering************/

  /************Fraud-o-meter Card rendering************/
  public fraudOMeterChart: Partial<fraudGaugeChartOption>;

  renderFraudOMeterChart() {
    if (!this.fraudScore) {
      return;
    }
    this.fraudScore = Number(this.getAbsoluteValue(Number(this.fraudScore)).toFixed(2));
    this.fraudOMeterChart = {
      series: [this.fraudScore],
      chart: {
        height: 300,
        type: 'radialBar',
      },
      labels: ['Fraud propensity'],
      plotOptions: {
        radialBar: {
          startAngle: -115,
          endAngle: 115,
          hollow: {
            margin: 0,
            size: '70%',
            background: this.getFraudOMeterColor(this.fraudScore),
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: 'front',
          },
          track: {
            background: '#F3EDC8',
            strokeWidth: '100%',
            margin: 5,
            dropShadow: {
              enabled: true,
              top: 0,
              left: 10,
              blur: 20,
              opacity: 0.5
            }
          },
          dataLabels: {
            name: {
              fontSize: '16px',
              color: '#fff'
            },
            value: {
              fontSize: '28px',
              color: '#fff'
            },
          },
        },
      },
      colors: this.getGradientColors(this.fraudScore),
    };
  }

  getFraudOMeterColor(score: number): string {
    if (score < 30) {
      return '#5F8670';
    } else if (score >= 30 && score <= 70) {
      return '#FF9800'; //0766AD
    } else {
      return '#DC8686';
    }
  }

  getGradientColors(score: number): string[] {
    // Assuming you want a gradient of shades based on the score
    if (score < 30) {
      return ['#FF9800']; // Shades of green
    } else if (score >= 30 && score <= 70) {
      return ['#9BB8CD']; // Shades of blue
    } else {
      return ['#FFBB5C']; // Shades of red
    }
  }
  /************END: Fraud-o-meter Card rendering************/

  /************Involvement Metrics************/
  /*public involvementMetricsChartLabels: string[] = ['Hospital', 'Doctor', 'TPA', 'Agency', 'Broker', 'Sales Advisory', 'Insured', 'Underwriters', 'Adjudicators', 'Data entry executive'];
  public involvementMetricsChartData = {
    labels: this.involvementMetricsChartLabels,
    datasets: []
  };
  public involvementMetricsChartType = 'radar';

  public involvementMetricsChartOptions = {
    responsive: true,
  };*/

  involvementMetricsChart: Partial<involvementMetricsChartOptions>;
  //public involvementMetricsChartLabels: string[] = ['Hospital', 'Doctor', 'TPA', 'Agency', 'Broker', 'Sales Advisory', 'Insured', 'Underwriters', 'Adjudicators', 'Data entry executive'];
  public involvementMetricsChartLabels: string[] = ['TPA', 'Agency', 'Broker', 'Sales Advisory', 'Insured'];
// Agency, Broker, Sales, Insured Person, Underwriter
  renderInvolvementMetricsChart() {
    if (environment['demo'] && this.tempTransactionCaseNum && this.fraudScore) {
      const seed = parseInt(this.tempTransactionCaseNum.slice(-4) + this.generateRangeFromScore(this.fraudScore) , 10); // this is used to generate, every time same set of random number for same case
      setTimeout(() => {
        this.involvementMetricsChart = {
          series: [
            {
              name: "",
              data: this.generateRandomArray(seed)
            }
          ],
          chart: {
            height: 360,
            type: "radar",
            /*events: {
              mounted: (chart) => {
                chart.windowResizeHandler();
              }
            }*/
          },
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            radar: {
              size: 140,
              polygons: {
                fill: {
                  colors: ["#f8f8f8", "#fff"]
                }
              }
            }
          },
          title: {
            text: ""
          },
          colors: ["#FF4560"],
          markers: {
            size: 4,
            colors: ["#fff"],
            strokeColors: ["#FF4560"],
            strokeWidth: 2
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              }
            }
          },
          xaxis: {
            categories: this.involvementMetricsChartLabels
          }
        };
      }, 2000);
    }
  }

  /*fetchInvolvementMetricsData() {
    if (environment['demo']) {
      const seed = parseInt(this.tempTransactionCaseNum.slice(-4), 10); // this is used to generate, every time same set of random number for same case
      this.involvementMetricsChartData['datasets'] = [
        { data: this.generateRandomArray(seed), label: 'Fraudulent Involvement' }
      ]
    }
  }*/

  generateRangeFromScore(fraudScore){
    // Calculate the lower bound
    let lowerBound:number = fraudScore - (fraudScore % 5);
    // Upper bound is lower bound + 5
    let upperBound:number = lowerBound + 5;

    return `${lowerBound}+${upperBound}`;
  }

  generateRandomArray(seed) {
    const getRandomNumber = this.seedRandom(seed);
    let length = this.involvementMetricsChartLabels.length;
    const randomArray = Array.from({ length }, () => Math.floor(getRandomNumber() * 41));

    return randomArray;
  }

  seedRandom(seed) {
    let state = seed || 0x2F6E2B1;

    return function random() {
      state = (state * 9301 + 49297) % 233280;
      return state / 233280;
    };
  }
  /************END : Involvement Metrics************/

  /************FWA Rules************/
  fwaRules = [];
  rulesNodeInIO = 'autoAdjResults';
  extractFraudRules() {
    if (this._IO && this.commonUtility.isArrayIterable(this._IO[this.rulesNodeInIO])) {
      let fraudRules = this._IO[this.rulesNodeInIO].filter(rules => rules.ruleCategory == 'FWA_RULES');
      if (this.commonUtility.isArrayIterable(fraudRules)) {
        this.fwaRules = [...fraudRules];
      } else if (environment['demo']) {
        this.fwaRules = this.extractFWARulesFromLocalJSON();
      }
    } else if (environment['demo']) {
      this.fwaRules = this.extractFWARulesFromLocalJSON();
    }
  }

  extractFWARulesFromLocalJSON() {
    const lastFourDigits = parseInt(this.tempTransactionCaseNum.slice(-4), 10);

    // for (const key in FWARulesLocalJSON) {
    //   if (lastFourDigits % parseInt(key, 10) === 0) {
    //     return FWARulesLocalJSON[key].fraudRules;
    //   }
    // }

    return FWARulesLocalJSON['default'].fraudRules; // Return default object if no match is found
  }
  /************END: FWA rules************/

  /************FWA Decision Form************/
  isFraud: boolean = false;
  _BaseEmitHandler(data) {
    console.log(data);
  }
  /************END: FWA Decision Form************/

  /** Utility Function****/
  formattedDate(dateString, expectedFormat?) {
    if (dateString && dateString != null) {
      // var d = moment(dateString, ['DD/MM/YYYY', 'x']);
      var d = moment(dateString, expectedFormat);
      return d.format('MM/DD/YYYY');
    }
    else
      return null
  }

  computeAge(dateOfBirth, admissionDt) {
    if (dateOfBirth && admissionDt) {
      var admissionDate_moment = moment(admissionDt, 'MM/DD/YYYY');
      var dateOfBirth_moment = moment(dateOfBirth, 'DD/MM/YYYY');
      return admissionDate_moment.diff(dateOfBirth_moment, 'years')
    }
    return null;
  }

  getAbsoluteValue(number) {
    return number ? Math.abs(number) : 0;
  }
  /**END:  Utility Function****/

  /**ngx-gauge threshold values**/
  /*gaugeThresHold = {
    "0": {
      "color": "#55c120",
      "bgOpacity": 0.4
    },
    "33": {
      "color": "#ef9f27",
      "bgOpacity": 0.4
    },
    "66": {
      "color": "#d52b2b",
      "bgOpacity": 0.4
    }
  }*/
  /**END : ngx-gauge threshold values**/
}
